import {
  FaArrowRight,
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaTelegramPlane,
  FaRss,
} from "react-icons/fa";

import { FaXTwitter } from "react-icons/fa6";

import { Link } from "react-router-dom";

import { PUBLIC_CATEGORIES } from "../config/categories";

import siteConfig from "../config/siteConfig";

import { getRssUrl } from "../services/api";

import "../styles/Footer.css";

const Footer = () => {
  const primaryCategories = PUBLIC_CATEGORIES.slice(0, 3);

  const secondaryCategories = PUBLIC_CATEGORIES.slice(3);

  const {
    name,
    logoText,
    logoMark,
    footerDescription,
    footerTagline,
    disclaimerText,
    copyright,
    social,
  } = siteConfig;

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-container">
          <section className="footer-brand">
            <Link
              to="/"
              className="footer-logo"
              aria-label={`${name} homepage`}
            >
              <span className="footer-logo-mark">{logoMark}</span>

              <span>
                <strong>{logoText}</strong>

                <small>{footerTagline}</small>
              </span>
            </Link>

            <p>{footerDescription}</p>

            <Link to="/about" className="footer-about-link">
              Learn more about us
              <FaArrowRight />
            </Link>

            <div className="footer-social">
              {social?.facebook && (
                <a
                  href={social.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`${name} Facebook`}
                >
                  <FaFacebookF />
                </a>
              )}

              {social?.instagram && (
                <a
                  href={social.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`${name} Instagram`}
                >
                  <FaInstagram />
                </a>
              )}

              {social?.x && (
                <a
                  href={social.x}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`${name} X`}
                >
                  <FaXTwitter />
                </a>
              )}

              {social?.youtube && (
                <a
                  href={social.youtube}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`${name} YouTube`}
                >
                  <FaYoutube />
                </a>
              )}

              {social?.telegram && (
                <a
                  href={social.telegram}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`${name} Telegram`}
                >
                  <FaTelegramPlane />
                </a>
              )}


              <a
                href={getRssUrl()}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`${name} RSS Feed`}
              >
                <FaRss />
              </a>
            </div>
          </section>

          <section className="footer-column">
            <h2>Main Categories</h2>

            <nav>
              {primaryCategories.map((category) => (
                <Link key={category.slug} to={`/category/${category.slug}`}>
                  {category.title}
                </Link>
              ))}
            </nav>
          </section>

          <section className="footer-column">
            <h2>More Updates</h2>

            <nav>
              {secondaryCategories.map((category) => (
                <Link key={category.slug} to={`/category/${category.slug}`}>
                  {category.title}
                </Link>
              ))}
            </nav>
          </section>

          <section className="footer-column">
            <h2>Information</h2>

            <nav>
              <Link to="/about">About Us</Link>

              <Link to="/contact">Contact</Link>

              <Link to="/editorial-policy">Editorial Policy</Link>

              <Link to="/corrections-policy">Corrections Policy</Link>

              <Link to="/privacy-policy">Privacy Policy</Link>

              <Link to="/disclaimer">Disclaimer</Link>

              <a href={getRssUrl()} target="_blank" rel="noopener noreferrer">
                RSS Feed
              </a>
            </nav>
          </section>
        </div>
      </div>

      <div className="footer-notice">
        <div className="footer-notice-inner">
          <strong>Important:</strong>

          <span>{disclaimerText}</span>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <span>{copyright}</span>

          <div>
            <Link to="/editorial-policy">Editorial</Link>

            <Link to="/corrections-policy">Corrections</Link>

            <Link to="/privacy-policy">Privacy</Link>

            <Link to="/disclaimer">Disclaimer</Link>

            <Link to="/contact">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
